
















































































import { Component, Vue, Inject } from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../lib/ajax';
import AbpBase from '../../../../lib/abpbase';
import Tools from '../../../../lib/tools';
import QuickTable from "../../../../components/table/table.vue";
@Component({
	name:'letterOfCommitment',
	components: {
		QuickTable
	}
})
export default class LetterOfCommitment extends AbpBase  {
    initData:any = {
    	showModal: false,		// 弹窗显示状态
    	formLoading: false,		// 表单提交状态
    	selectLoading: false,	// select搜索状态
    	user: {					// 当前登录账户信息
    		organization: {
    			displayName: ''
    		},
    		name: ''
    	},
    	searchData: {
    		CommitMentType: '',
    		Name: ''
    	},
    	commitMentTypes: [],	// 承诺书类型及数据
    	commitDetail: {			// 承诺书签署详情
    		id: undefined,
    		userName: '',
    		creationTime: ''
    	},
    	columns: [
            {
            	title: '序号',
                type: 'index',
                width: 62,
                align: 'center'
            },
            {
                title: '承诺书类型',
                key: 'commitMentTypeName'
            },
            {
                title: '承诺人',
                render: (h:any, params:any) => {
                	if(params.row.creatorUser) {
                		return h('span', params.row.creatorUser.name);
                	}
                	return h('span', '');
                }
            },
            {
                title: '承诺日期',
                key: 'creationTime',
                render: (h:any, params:any) => {
                	return h('span', Tools.formatDate(params.row.creationTime));
                }
            },
            {
                title: '操作',
                width: 130,
                render: (h:any, params:any) => {
                	return h('span', [
                		h('Button', {
                			props: {
                				type: 'primary',
                				size: 'small'
                			},
							on: {
								click: () => {
									this.handleGetDetail(params.row.id);
								}
							}
                		}, '查看'),
                		h('Button', {
                			props: {
                				type: 'error',
                				size: 'small'
                			},
                			style: {
                				marginLeft: '10px'
                			},
							on: {
								click: () => {
									this.handleDelete(params.row.id);
								}
							}
                		}, '删除')
                	])
                }
            }
        ]
    }
    sign:any = {
    	show: false,
    	signedId: null,			// 已签署承诺书ID
    	signed: null,			// 已签署类型
    	signValue: '',
    	focus: false,
    	datetime: ''
    }
    // 初始化
    async init() {
    	// 获取承诺书类型
    	await Ajax.get('/api/services/app/SysBaseData/GetCatalogItemAsync', {params: {DirectoryCode : 'CT'}}).then((res:any)=>{
            this.initData.commitMentTypes = res.data.result.items;
       	})
    	
    	// 获取当前登录账户信息
    	await this.$store.dispatch('session/init').then(() => {
    		this.initData.user = this.$store.state.session.user;
    	})
    	// 获取当天日期、格式化日期
    	this.sign.datetime = Tools.formatDate('now', 'yyyy年MM月dd日');
    	
    	// 查询当前账户是否已经签署过承诺书
    	this.GetCommited();
    	
    }
    // 查询当前账户是否已经签署过承诺书
    async GetCommited() {
    	await Ajax.get('/api/services/app/Commitment/GetByPageAsync', {params: {Name: this.initData.user.name}}).then((res:any)=>{
			res = res.data.result;
            if(res && res.items && res.items.length > 0) {
            	this.sign.signedId = res.items[0].id;
				this.sign.signed = res.items[0].commitMentType;
				this.initData.commitMentTypes.map( (item:any) => {
					res.items.forEach( (element:any) => {
						if(item.directoryValue == element.commitMentType){
							item.signed = true;
							item.signedId = element.id;
						}
					});
					return item;
				} )
            }else{
            	this.sign.signed = null;
            }
        }).catch(() => {
        	
        })
    }
    GetData() {
        (this as any).$refs.table.GetData();
    }
    // 删除
    async handleDelete(id:any) {
    	this.$Modal.confirm({
            title: '操作确认',
            content: '是否确认删除此承诺书信息？',
            onOk: () => {
                Ajax.delete('/api/services/app/Commitment/DeleteAsync', {params: {Id: id}}).then((res:any)=>{
	                this.$Message.success('删除成功!');
	                this.GetCommited();
                	this.GetData();
	            })
            }
        });
    }
    // 打开签署承诺书
    handleGoSign(item:any,index:any) {
		this.initData.showModal = false;
    	setTimeout(() => {
			let commit:any = this.initData.commitMentTypes[index];
    		// 点击已签署
    		if(item.signed) {
				this.handleGetDetail(item.signedId);
    		}else{
				this.sign.signed = null;
    			this.initData.commitDetail.id = undefined;
	    		this.initData.commitDetail.commitMentType = commit.directoryValue;
	    		this.initData.commitDetail.commitMentTypeName = commit.directoryName;
	    		this.initData.commitDetail.commitMentTypeRemark = commit.remark;
	    		this.initData.commitDetail.userName = this.initData.user.organization.displayName +'/'+ this.initData.user.name;
	    		this.initData.commitDetail.creationTime = this.sign.datetime;
	    		this.sign.signValue = '';
	    		this.sign.show = true;
    		}
    	}, 300)
    }
    // 签署承诺书键盘事件
    handleSignKeyup() {
    	if(this.sign.signValue.length > 11) {
    		this.sign.signValue = this.sign.signValue.substring(0, 11);
    	}
    }
    // 确认签署承诺书
    async handleSignSubmit() {
    	if(this.sign.signValue !== '本人已阅读并了解承诺书') {
    		this.$Message.error('请认真阅读并输入正确的文字！');
    		return;
    	}
    	await Ajax.post('/api/services/app/Commitment/CreateAsync', {commitMentType: this.initData.commitDetail.commitMentType}).then((res:any) => {
    		this.$Message.success('签署成功！');
    		this.sign.show = false;
    		this.GetCommited();
    		this.GetData();
    	})
    }
    // 获取承诺书详情
    async handleGetDetail(id:any) {
    	await Ajax.get('/api/services/app/Commitment/GetDetailAsync', {params: {id: id}}).then((res:any) => {
			res = res.data.result;
    		this.initData.commitDetail.id = res.id;
    		this.initData.commitDetail.commitMentType = res.commitMentType;
    		this.initData.commitDetail.commitMentTypeName = res.commitMentTypeName;
    		this.initData.commitDetail.commitMentTypeRemark = res.commitMentTypeRemark;
    		this.initData.commitDetail.userName = res.creatorUserDep.displayName +'/'+ (res.creatorUser ? res.creatorUser.name : '');
    		this.initData.commitDetail.creationTime = Tools.formatDate(res.creationTime, 'yyyy年MM月dd日');
    		this.sign.signValue = '本人已阅读并了解承诺书';
			this.sign.show = true;
			this.sign.datetime = Tools.formatDate(res.creationTime, 'yyyy年MM月dd日');
			this.sign.signed = res.commitMentType;
    	})
    }
    async mounted() {
    	
    	this.init();
    	this.GetData();
    	
    }
}
